/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-curly-newline */
import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useAuth } from '~/hooks/contexts/useAuth';
import { useUserRole } from '~/hooks/contexts/useUserRole';
import { routesConfig } from './routeRoles';

export default ({ component: Component, ...rest }) => {
  const { isAuthenticated } = useAuth();
  const { hasAnyRole } = useUserRole();

  const validateRoles = () => {
    const routesFinded = routesConfig.filter(
      (route) => route.route === rest.path,
    );

    if (!routesFinded.length) return true;

    return routesFinded.some((route) => hasAnyRole(route.roles));
  };

  return (
    <Route
      exact
      {...rest}
      render={(props) =>
        isAuthenticated() ? (
          validateRoles() ? (
            <Component {...props} />
          ) : (
            <Redirect
              to={{ pathname: '/homeDash', state: { from: props.location } }}
            />
          )
        ) : (
          <Redirect to={{ pathname: '/', state: { from: props.location } }} />
        )
      }
    />
  );
};
